<template>
  <div class="produits-container">
    <div class="produits-title">
      <h1>NOS PRODUITS</h1>
    </div>
        <div class="breadcrumb">
        <a href="/">Accueil</a> > <RouterLink to="/produits">Produits</RouterLink>
      </div>
    <div class="produits-content">

      <div class="produits-description">
        <h1>Produits de Laboratoire</h1>
        <p>
          Dans notre Société SupraCare, nous proposons une gamme diversifiée de produits de haute qualité conçus pour répondre aux besoins variés de la recherche scientifique
          et des expérimentations. Nos consommables sont fiables et fabriqués avec précision pour garantir des résultats cohérents. Les machines d’analyse que nous fournissons sont 
          des outils de pointe offrant une analyse précise pour diverses applications. Des spectrophotomètres aux systèmes de chromatographie, chaque instrument assure des données fiables
          pour des prises de décision éclairées. Nos produits chimiques respectent des normes de pureté strictes, garantissant des performances optimales dans les expériences. Toutes nos offres 
          sont accompagnées de certificats de haute qualité sur le marché, assurant leur fiabilité. Nous accordons une importance particulière à la satisfaction du client et visons à faciliter la recherche innovante.
        </p>
      </div>
           
      <div class="container">
        <div class="produits-categories">
          <div class="category-card">
            <img src="@/assets/AKLIDES.png" alt="Équipement Labo">
            <RouterLink to="/equipementlabo">Équipement Labo</RouterLink>
          </div>
          <div class="category-card">
            <img src="@/assets/glove-latex.jpg" alt="consomablesComp">
            <RouterLink to="/consomablesComp">Consommables</RouterLink>
          </div>
          <div class="category-card">
            <img src="@/assets/REACTIF-.jpg" alt="Réactifs">
            <RouterLink to="/reactifs">Réactifs</RouterLink>
          </div>
          <div class="category-card">
            <img src="@/assets/bact.jpg" alt="Bactériologie">
            <RouterLink to="/bacteriologieComp">Bactériologie</RouterLink>
          </div>
          <div class="category-card">
            <img src="@/assets/chimique.jpg" alt="Produits Chimiques">
            <RouterLink to="/chimiquesComp">Produits Chimiques</RouterLink>
          </div>
          <div class="category-card">
            <img src="@/assets/vita.png" alt="Vitamines & Minéraux">
            <RouterLink to="/vitamines-mineraux">Vitamines & Minéraux</RouterLink>
          </div>
      
        <div class="category-card">
            <img src="@/assets/topstar.png" alt="Top Star">
            <RouterLink to="/topstar">Top Star</RouterLink>
          </div> 
          <!--
            <div class="category-card">
            <img src="@/assets/glucotest.png" alt="Glucotest">
            <RouterLink to="/glucotest">Glucotest</RouterLink>
          </div>
          -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ProduitsI',
};
</script>

<style scoped>
/* === Style clair par défaut (inchangé) === */

/* Conteneur principal */
.produits-container {
  padding: 0;
  position: relative;
  text-align: left;
  z-index: 1;
  overflow: hidden;
  background: white;
  color: #333;
}

/* Titre des produits */
.produits-title {
  background: linear-gradient(to right, #a8f8e8, rgb(127, 121, 235), #a8f8e8);
  background-size: cover;
  background-position: center;
  color: #1d1343;
  padding: 10px 20px;
  text-align: center;
  margin-bottom: 40px;
  font-family: 'Helvetica Neue', sans-serif;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.produits-title a:hover {
  transform: scale(1.1);
  box-shadow: 0 5px 15px rgba(246, 239, 239, 0.4);
}

/* Fil d'Ariane (breadcrumb) */
.breadcrumb {
  font-size: 10px;
  color: #888;
  margin-top: 0px;
  padding: 10px 50px;
}

.breadcrumb a {
  color: #1c1c1d;
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb a:hover {
  color: #0056b3;
}

/* Contenu de la description et catégories */
.produits-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
  padding: 0 1%;
}

/* Section de description (à droite) */
.produits-description {
  flex: 1;
  padding: 50px;
  border-radius: 8px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 16px;
  font-weight: 300;
  color: #333;
  line-height: 1.6;
}

.produits-description h1 {
  font-size: 3rem;
  color: #1d1343;
  margin-bottom: 15px;
  font-weight: 700;
}

.produits-description p {
  font-size: 1.2rem;
  color: black;
}

/* Conteneur des catégories (à gauche) */
.produits-categories {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 25px;
  justify-items: center;
}

/* Cartes des catégories */
.category-card {
  width: 80%;
  text-align: center;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.category-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.15);
}

/* Images des catégories */
.category-card img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

/* Liens des catégories */
.category-card a {
  display: block;
  padding: 1px;
  background-color: #1d1343;
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 600;
  text-decoration: none;
  transition: background-color 0.3s;
}

.category-card a:hover {
  background-color: #2a1b5b;
}

/* Responsive Design */
@media (max-width: 768px) {
  .produits-content {
    flex-direction: column;
  }

  .produits-categories {
    grid-template-columns: repeat(2, 1fr);
  }

  .category-card {
    width: 100%;
    height: auto;
  }
}

@media (max-width: 500px) {
  .produits-categories {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 1300px) {
  .produits-title {
    font-size: clamp(1.5rem, 5vw, 1rem);
    padding: 60px 0px;
  }

  .produits-description {
    padding: 20px;
  }

  .produits-description p {
    font-size: 0.9rem;
  }
}

/* === 🌙 Mode sombre automatique === */
@media (prefers-color-scheme: dark) {
  .produits-container {
    background: #0b0f14;
    color: #eaeaea;
  }

  .produits-title {
    background: linear-gradient(to right, #09213a, #271b4f, #09213a);
    color: #a8f8e8;
  }

  .breadcrumb {
    color: #aaa;
  }

  .breadcrumb a {
    color: #a8f8e8;
  }

  .breadcrumb a:hover {
    color: #61dafb;
  }

  .produits-description {
    color: #d1d5db;
  }

  .produits-description h1 {
    color: #73d8cf;
  }

  .produits-description p {
    color: #e0e0e0;
  }

  .category-card {
    background-color: #182230;
    box-shadow: 0 4px 10px rgba(255, 255, 255, 0.05);
  }

  .category-card a {
    background-color: #00998b;
    color: white;
  }

  .category-card a:hover {
    background-color: #00bfa5;
  }
}
</style>
